
export default {
  getFilterURL (data) {
    let url = '';
    _.each(data, function (value , key) {
      url += (value) ? '&' + key + '=' + encodeURI(value) : '';
    });
    return url;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/admin/services/helper.js